import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { PermissionsService } from '../services/permissions.service';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';

@Component({
  selector: 'app-annadaan',
  templateUrl: './annadaan.component.html',
  styleUrls: ['./annadaan.component.scss']
})
export class AnnadaanComponent implements OnInit {
 public payment_report: any;
  allAnnadaanBooking: any;
  public from_date = moment(new Date()).format('YYYY-MM-DD');
  public to_date = moment(new Date()).format('YYYY-MM-DD');
  public perPage = 100;
  public totalCount = 0;
  public page = 1;
  public maxDate = ''; // moment(new Date()).format('YYYY-MM-DD');
  public payment_status = '';
  public annakshetra_meal_type_id = '';
  public allMealTypes: any = [];

  constructor(
    private apiService: ApiService,
    private appComponent: AppComponent,
    public permissionsService: PermissionsService,
    private router: Router

    ) { }

  ngOnInit() {
    this.getList('');
    this.getMealTypes();
  }

  navigateTo(url) {
    this.router.navigate([url]);
  }

  getList(_type) {
    this.appComponent.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    this.apiService.getDataFromServer(`/annakshetra_donations?from_date=${from_date}&end_date=${to_date}&page=${this.page}&perpage=${this.perPage}&payment_status=${this.payment_status}&annakshetra_meal_type_id=${this.annakshetra_meal_type_id}`).subscribe(
      (res: any) => { 
        this.appComponent.hideLoader();
        this.allAnnadaanBooking = res;
        // Filter only successful payments
        // this.allAnnadaanBooking.data = this.allAnnadaanBooking.data.filter(item => {
        //   return item.payment_details && item.payment_details.length > 0 && item.payment_details[0].spRespStatus === 'SUCCESS';
        // });
        this.allAnnadaanBooking.data.map(res => {
          // res.created_at = moment.utc(res.created_at).local().format('DD-MM-YYYY h:mm a z');
          
          res.donation_date = moment.utc(res.donation_date).local().format('DD-MM-YYYY');
        });
        this.totalCount = this.allAnnadaanBooking.data.length;
      },
      err => {
        console.log(err);
      }
    );
  }

  getMealTypes() {
    this.apiService.getDataFromServer('/annakshetra_meal_types').subscribe(
      res => {
        this.allMealTypes = res['data'];
      },
      err => {
        console.log(err);
      }
    );
  }

  exportData() {
    this.appComponent.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    
    this.apiService.getDataFromServer(`/export_annakshetra_donations?from_date=${from_date}&end_date=${to_date}&payment_status=${this.payment_status}&annakshetra_meal_type_id=${this.annakshetra_meal_type_id}`).subscribe((res: any) => {
      if(res.status_code === 200) {
        const fileArry = res.data.split('/uploads/');
        this.apiService.getBlobFileFromServer(res.data).subscribe(res => {
          this.appComponent.hideLoader();
          let blob:any = new Blob([res], { type: res.type });
          const url = window.URL.createObjectURL(blob);
          let file_name = fileArry[fileArry.length - 1];
          saveAs(blob, file_name);
        }, (error) => {
          this.appComponent.hideLoader();
        });
      }
      this.appComponent.hideLoader();
    }, (error) => {
      this.appComponent.hideLoader();
      console.log('error' , error);
    });
  }


}
